module.exports = __webpack_public_path__ + "img/role-marketing.f51da938.png";